import { ApiProperty } from "@nestjs/swagger";
import { IsAlphanumeric, IsNotEmpty, IsNumber, IsOptional } from "class-validator";

export class CodeLisSOItemReq {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    saleOrderItemId: number;

}